import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { type LocationModel } from "src/types/location";

import { apiGetLocationFile, apiGetLocationFiles, apiGetLocationsTree } from "./location.api";
import apiGetLocationBreadcrumbsPath from "./locationBreadcrumbs.api";

export const useBreadcrumbsDataQuery = (selectedLocationId: string | undefined): UseQueryResult<ApiBreadcrumbItemDto[], Error> =>
  useQuery<ApiBreadcrumbItemDto[], Error>({
    queryKey: ["breadcrumbs", selectedLocationId],
    queryFn: async () => {
      if (selectedLocationId) {
        return apiGetLocationBreadcrumbsPath(selectedLocationId);
      }
      return [];
    },
    staleTime: Infinity,
  });

export const useLocationsDataQuery = (): UseQueryResult<ODataResponse<LocationModel>, Error> =>
  useQuery<ODataResponse<LocationModel>, Error>({
    queryKey: ["locations"],
    queryFn: async () => apiGetLocationsTree(),
    staleTime: Infinity,
  });

export const useLocationFilesQuery = (locationId: string | undefined): UseQueryResult<LocationFileDto[], Error> =>
  useQuery<LocationFileDto[], Error>({
    queryKey: ["locationFiles", locationId],
    queryFn: async () => apiGetLocationFiles(locationId),
    staleTime: Infinity,
    enabled: !!locationId,
  });

export const useLocationFileQuery = (fileId: string | undefined): UseQueryResult<Blob, Error> =>
  useQuery({
    queryKey: ["file", { id: fileId }],
    queryFn: async () => apiGetLocationFile(fileId, false),
    staleTime: Infinity,
    enabled: !!fileId,
  });
